export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9929.5809ee9a.jpg";